import { render } from "./QualityFeatures.vue?vue&type=template&id=87fb3c48"
import script from "./QualityFeatures.vue?vue&type=script&lang=js"
export * from "./QualityFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__